// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"d54c2d5d","754":"f9d5bbf5"}[chunkId] + ".chunk.js";
};